export default "__VITE_ASSET__CCySxCJT__"